import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/App.css";

import styled from "styled-components";
import Home from "./pages/Home";
import Footer from "./Layout/Footer";
import Newsletter from "./pages/Newsletter";
import NotFound from "./pages/NotFound";

function App() {
  const [toggler, setToggler] = useState(true);
  const [theme, setTheme] = useState(true);

  useEffect(() => {
    localStorage.getItem("theme") &&
      setTheme(
        localStorage.getItem("theme").toString() === "true" ? true : false
      );
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", `${theme}`);
  }, [theme]);

  return (
    <div className={theme ? "App light" : "App"}>
      <Header>
        <div className="toggler" onClick={() => setToggler(!toggler)}>
          <div className={toggler ? "toggler_btn" : "toggler_btn active"}></div>
        </div>
        {toggler ? (
          ""
        ) : (
          <Nav>
            <div className="top">
              <a href="/">Home</a>
              <div className="theme_toggler_container">
                <span>Theme:</span>
                <div className="theme_toggler" onClick={() => setTheme(!theme)}>
                  <div
                    className={
                      theme ? "theme_toggler_btn active" : "theme_toggler_btn"
                    }
                  ></div>
                  <div
                    className={
                      theme ? "theme_toggler_grid active" : "theme_toggler_grid"
                    }
                  >
                    <img
                      src={theme ? "/image/moon.png" : "/image/sun.png"}
                      alt="toggle"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <a
                href="http://ah-jim-seed.web.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                Akhlak Hossain Jim
              </a>
              <br />
              <span>
                &copy;{" "}
                {new Date().getFullYear().toString() === "2022"
                  ? ""
                  : `2022 - `}
                {new Date().getFullYear()}
              </span>
              <br />
              <span className="version">
                <strong>App Version: </strong>v1.0.0
              </span>
            </div>
          </Nav>
        )}
      </Header>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/newsletter/:id" element={<Newsletter />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

const Header = styled.header`
  z-index: 200;
  display: flex;
  justify-content: flex-end;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  .toggler {
    z-index: 100;
    margin: 15px 20px;
    width: 20px;
    height: 22px;
    &_btn {
      margin: 10px 0;
      height: 2px;
      width: 20px;
      background: var(--text-color);
      position: relative;
      transition: all cubic-bezier(0.67, -0.62, 0, 1.53) 300ms;
      &::before {
        position: absolute;
        top: -8px;
        right: 0;
        height: 2px;
        width: 20px;
        background: var(--text-color);
        content: "";
      }
      &::after {
        position: absolute;
        bottom: -8px;
        right: 0;
        height: 2px;
        width: 20px;
        background: var(--text-color);
        content: "";
      }
      &.active {
        transform: rotate(90deg);
        background: transparent;
        &::before {
          transform: rotate(45deg);
          top: 0;
          width: 25px;
        }
        &::after {
          transform: rotate(-45deg);
          top: 0;
          width: 25px;
        }
      }
    }
  }
`;

const Nav = styled.nav`
  position: fixed;
  padding: 50px 30px 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: var(--nav-bg);
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  width: min(80vw, 400px);
  .top {
    a {
      color: var(--link-color);
      font-size: var(--small-text);
      text-decoration: none;
      margin-bottom: 15px;
    }
    .theme_toggler_container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .theme_toggler {
      margin: 10px 20px;
      position: relative;
      height: 20px;
      width: 40px;
      border-radius: 20px;
      border: 1px solid var(--text-color);
      background: var(--text-color);
      align-items: center;
      &_btn,
      &_grid {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        position: absolute;
        top: 0px;
      }
      &_btn {
        left: 0;
        background: var(--bg);
        &.active {
          left: auto;
          right: 0;
        }
      }
      &_grid {
        right: 0;
        &.active {
          right: auto;
          left: 0;
        }
        img {
          height: 100%;
        }
      }
    }
  }
  .bottom {
    a {
      color: var(--link-color);
      font-size: var(--small-text);
      text-decoration: none;
    }
    span {
      font-size: var(--xSmall-text);
      &.version {
        font-size: calc(2px + 2vmin);
      }
    }
  }
`;

export default App;
